import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { Box, Drawer } from '@mui/material'
import useResponsive from '../../../hooks/useResponsive'
import Scrollbar from '../../../components/Scrollbar'
import { useTranslation } from 'react-i18next'
import Logo from '../../../components/Logo'
import NavSection from '../../../components/NavSection'

const NAV_WIDTH = 270

// const StyledAccount = styled('div')(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   padding: theme.spacing(2, 2.5),
//   borderRadius: Number(theme.shape.borderRadius) * 1.5,
//   backgroundColor: alpha(theme.palette.grey[500], 0.12)
// }))

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func
}

export default function Nav ({ openNav, onCloseNav }: any) {
  const { pathname } = useLocation()
  const theme = useTheme()
  const { t } = useTranslation()

  const isDesktop = useResponsive('up', 'lg')

  const navConfig = [
    {
      title: t('header.title.dashboard'),
      path: '/dashboard'
    },
    {
      title: t('header.title.trainingBench'),
      path: '/routine'
    },
    {
      title: t('header.title.workouts'),
      path: '/workouts'
    },
    {
      title: t('header.title.athletes'),
      path: '/athletes'
    }
  ]

  useEffect(() => {
    if (openNav) {
      onCloseNav()
    }
  }, [pathname])

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' }
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
        <Logo sx={{ width: 160 }} />
      </Box>
      <NavSection data={navConfig} />
      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  )

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH }
      }}
    >
      {isDesktop
        ? (
          <Drawer
            open
            variant="persistent"
            PaperProps={{
              sx: {
                width: NAV_WIDTH,
                borderRightStyle: 'solid',
                backgroundColor: theme.palette.grey[900]
              }
            }}
          >
            {renderContent}
          </Drawer>)
        : (
          <Drawer
            open={openNav}
            onClose={onCloseNav}
            ModalProps={{
              keepMounted: true
            }}
            PaperProps={{
              sx: { width: NAV_WIDTH }
            }}
          >
            {renderContent}
          </Drawer>)}
    </Box>
  )
}
